/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { Form, Select, Row, Col, Modal, Button } from 'antd';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames/bind';
import Enums from 'utils/EnumsManager';
import { FormattedMessage } from 'react-intl';
import iconOrder from 'assets/images/icons/icon-order-32.png';
import { setSorterValue, resetSorterValue, setModalSelectedValueAsInitial, resetModalSorter } from '../../flow/actions';
import { resetSorterIfNecessary, checkOptionsAvailable } from '../../utils/checkReportSorter';
import styles from '../../index.less';

const cx = classNames.bind(styles);

const { DROPZONES, SortOrders, REPORTS } = Enums;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;
const { ascend, descend } = SortOrders;
const { GROUPSORTER, ORTHERSSORRTER } = REPORTS.SORTER;
const { Option } = Select;
const FormItem = Form.Item;

class OrderModal extends React.Component {
  state = {
    visible: false
  };

  handleClick = () => {
    const { sorter, resetModalSorter, selectedCols } = this.props;
    resetSorterIfNecessary(sorter, selectedCols, resetModalSorter);
    this.setState({
      visible: true,
    });
  };

  handleCancel = () => {
    const { resetSorterValue } = this.props;
    this.setState({ visible: false });
    resetSorterValue();
  };

  handleOk = () => {
    const { form, setModalSelectedValueAsInitial } = this.props;
    const { validateFieldsAndScroll } = form;
    validateFieldsAndScroll((errors, values) => {
      if (!errors) {
        setModalSelectedValueAsInitial();
        this.setState({ visible: false });
      }
    });
  };

  handleSorterChange = (fieldsKey, value) => {
    const { setSorterValue } = this.props;
    setSorterValue(fieldsKey, 'direction', value === ascend ? descend : ascend);
  }

  optionsHaveActions = sorterKey => {
    const { selectedCols } = this.props;
    const selectedValue = selectedCols.find(col => col.name === sorterKey);
    if (selectedValue && _.isArray(selectedValue.actions)) {
      return selectedValue.actions;
    } else if (selectedValue && _.isString(selectedValue.actions)) {
      return [selectedValue.actions];
    }
    return [];
  }

  render() {
    const { visible } = this.state;
    const { form, selectedCols, sorter } = this.props;
    const { getFieldDecorator } = form;
    const { groupAndAggregateSorter, otherSorter } = sorter;

    const footerAction = [
      (
        <Button key="cancel" onClick={this.handleCancel} className={cx('filter-modal-cusbtn')}>
          <FormattedMessage id="global.ui.button.cancel" />
        </Button>
      ),
      (
        <Button key="submit" type="primary" onClick={this.handleOk}>
          <FormattedMessage id="global.ui.button.ok" />
        </Button>
      ),
    ];

    return (
      <React.Fragment>
        <Button onClick={this.handleClick}>
          <FormattedMessage id="page.ReportTableSetup.sort" />
        </Button>
        <Modal
          title={
            <FormattedMessage id="page.ReportTableSetup.sort">
              {text => <span className={cx('sorter-modal-title')}>{text}</span>}
            </FormattedMessage>
          }
          visible={visible}
          onCancel={this.handleCancel}
          footer={footerAction}
        >
          <Form>
            <div>
              <FormattedMessage id="page.ReportTableSetup.sortTitle" values={{ num: 1 }}>
                {text => <span className={cx('sorter-modal-title')}>{text}</span>}
              </FormattedMessage>
            </div>
            <Row gutter={16}>
              <Col span={10}>
                <FormItem>
                  {getFieldDecorator(`${GROUPSORTER}_name`, {
                    rules: [{ required: true, message: <FormattedMessage id="global.errors.required" /> }]
                  })(
                    <Select className="full-width">
                      {selectedCols.map(col => (
                        checkOptionsAvailable(col) && (col.belongTo === GROUPS || col.belongTo === AGGREGATES) &&
                        <Option key={col.id} value={col.name}>{col.label}</Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
              {groupAndAggregateSorter.selectedValue.name.value && !_.isEmpty(this.optionsHaveActions(groupAndAggregateSorter.selectedValue.name.value)) &&
                <Col span={10}>
                  <FormItem>
                    {getFieldDecorator(`${GROUPSORTER}_action`, {
                      rules: [{ required: true, message: <FormattedMessage id="global.errors.required" /> }]
                    })(
                      <Select className="full-width">
                        {this.optionsHaveActions(groupAndAggregateSorter.selectedValue.name.value).map(action => (
                          <Option key={action} value={action}><FormattedMessage id={`page.ReportTableSetup.actions.${action}`} /></Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
              }
              {groupAndAggregateSorter.selectedValue.name.value &&
                <Col span={4}>
                  <img
                    alt="Column order"
                    className={`cursor-pointer mt-lg ${cx('iconOrder', {
                        ascending: groupAndAggregateSorter.selectedValue.direction === ascend,
                      })}`}
                    onClick={() => this.handleSorterChange(GROUPSORTER, groupAndAggregateSorter.selectedValue.direction)}
                    src={iconOrder}
                  />
                </Col>
              }
            </Row>
            <div>
              <FormattedMessage id="page.ReportTableSetup.sortTitle" values={{ num: 2 }}>
                {text => <span className={cx('sorter-modal-title')}>{text}</span>}
              </FormattedMessage>
            </div>
            <Row gutter={16}>
              <Col span={10}>
                <FormItem>
                  {getFieldDecorator(`${ORTHERSSORRTER}_name`, {
                    rules: [{ required: true, message: <FormattedMessage id="global.errors.required" /> }]
                  })(
                    <Select className="full-width">
                      {selectedCols.map(col => (
                        checkOptionsAvailable(col) &&
                        <Option key={col.id} value={col.name}>{col.label}</Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
              {otherSorter.selectedValue.name.value && !_.isEmpty(this.optionsHaveActions(otherSorter.selectedValue.name.value)) &&
                <Col span={10}>
                  <FormItem>
                    {getFieldDecorator(`${ORTHERSSORRTER}_action`, {
                      rules: [{ required: true, message: <FormattedMessage id="global.errors.required" /> }]
                    })(
                      <Select className="full-width">
                        {this.optionsHaveActions(otherSorter.selectedValue.name.value).map(action => (
                          <Option key={action} value={action}><FormattedMessage id={`page.ReportTableSetup.actions.${action}`} /></Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
              }
              {otherSorter.selectedValue.name.value &&
                <Col span={4}>
                  <img
                    alt="Column order"
                    className={`cursor-pointer mt-lg ${cx('iconOrder', {
                        ascending: otherSorter.selectedValue.direction === ascend,
                      })}`}
                    onClick={() => this.handleSorterChange(ORTHERSSORRTER, otherSorter.selectedValue.direction)}
                    src={iconOrder}
                  />
                </Col>
              }
            </Row>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapPropsToFields = props => {
  const { sorter } = props;
  const { createFormField } = Form;
  const { groupAndAggregateSorter, otherSorter } = sorter;
  return {
    [`${GROUPSORTER}_name`]: createFormField({
      ...groupAndAggregateSorter.selectedValue.name,
      value: groupAndAggregateSorter.selectedValue.name.value,
    }),
    [`${GROUPSORTER}_action`]: createFormField({
      ...groupAndAggregateSorter.selectedValue.action,
      value: groupAndAggregateSorter.selectedValue.action.value,
    }),
    [`${ORTHERSSORRTER}_name`]: createFormField({
      ...otherSorter.selectedValue.name,
      value: otherSorter.selectedValue.name.value,
    }),
    [`${ORTHERSSORRTER}_action`]: createFormField({
      ...otherSorter.selectedValue.action,
      value: otherSorter.selectedValue.action.value,
    }),
  };
};
const onFieldsChange = (props, changedFields) => {
  const { setSorterValue } = props;
  Object.keys(changedFields).forEach(field => {
    // this function is used to select the field key and action key, fieldKeys[0] is the field key and fieldKeys[1] is the action key.
    const fieldKeys = field.split('_');
    setSorterValue(fieldKeys[0], fieldKeys[1], changedFields[field]);
    // this function is used to reset the action when change the field
    if (fieldKeys[1] === 'name') {
      setSorterValue(fieldKeys[0], 'action', { value: '' });
    }
  });
};

const mapStateToProps = ({ global, reportSetup }) => ({
  lang: global.language,
  selectedCols: reportSetup.sider.selectedCols,
  sorter: reportSetup.sorter,
});

const mapDispatchToProps = {
  setSorterValue,
  resetSorterValue,
  setModalSelectedValueAsInitial,
  resetModalSorter
};

const enhancers = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  Form.create({
    mapPropsToFields,
    onFieldsChange
  }),
);

export default enhancers(OrderModal);



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/components/OrderModal/index.jsx